import { mockComponent } from 'bloko/common/setupMockComponents';

const { SocialIconView } = jest.requireActual('bloko/blocks/socialIcon/index.js');
export { SocialIconView };

export default mockComponent('SocialIcon', null, {
    withChildren: true,
});
